import React from "react";

/**
 * ContactPage: Contact information page
 * Contact form temporarily removed
 */
const ContactPage: React.FC = () => {
  // No form logic; only static contact info for now

  return (
    <div className="min-h-screen">
      {/* Header */}
      <section className="section-padding gradient-hero">
        <div className="container-max text-center">
          <div className="animate-fade-in">
            <h1 className="heading-1 mb-6">Contact Us</h1>
            <p className="body-large max-w-3xl mx-auto">
              Get in touch with our team. We're here to help you protect what matters most.
            </p>
          </div>
        </div>
      </section>

      <div className="section-padding bg-white">
        <div className="container-max">
          <div className="grid grid-cols-1 gap-12">
            {/* Contact Information */}
            <div className="animate-fade-in">
              <h2 className="heading-2 mb-8">Get in Touch</h2>
              
              <div className="space-y-8">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-primary-100 rounded-2xl flex items-center justify-center mr-4">
                    <svg className="w-6 h-6 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">Email</h3>
                    <p className="text-gray-600">info@readytoclaim.com</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 bg-primary-100 rounded-2xl flex items-center justify-center mr-4">
                    <svg className="w-6 h-6 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.25 6.75l8.955 5.247a1.5 1.5 0 001.49 0L21.75 6.75M3 18.75h18a1.5 1.5 0 001.5-1.5V6.75A1.5 1.5 0 0021 5.25H3a1.5 1.5 0 00-1.5 1.5v10.5a1.5 1.5 0 001.5 1.5z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">General Inquiries</h3>
                    <p className="text-gray-600">Please email us and we’ll respond shortly.</p>
                  </div>
                </div>
              </div>

              <div className="mt-12 card p-8">
                <h3 className="heading-3 mb-4">Need Immediate Help?</h3>
                <p className="body-medium mb-6">
                  If you're dealing with a recent disaster and need urgent assistance,
                  we can schedule an immediate service. Our specialist will conduct a video call to document your losses and help you prepare for insurance claims.
                </p>
                <a
                  href="/try"
                  className="btn-primary inline-block"
                >
                                      Schedule Service
                </a>
              </div>
            </div>
            {/* Contact form removed for now */}
          </div>
        </div>
      </div>

      {/* FAQ Section */}
      <section className="section-padding gradient-primary">
        <div className="container-max">
          <div className="text-center mb-16 animate-slide-up">
            <h2 className="heading-2 mb-6">
              Common Questions
            </h2>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="card p-8 animate-fade-in">
              <h3 className="heading-3 mb-4">
                How quickly can you process my inventory?
              </h3>
              <p className="body-medium">
                The video service takes 30-60 minutes. After the call, our specialist completes documentation and reverse image search processing within 24-48 hours.
              </p>
            </div>

            <div className="card p-8 animate-fade-in" style={{animationDelay: '0.1s'}}>
              <h3 className="heading-3 mb-4">
                What happens during the service?
              </h3>
              <p className="body-medium">
                We conduct a recorded Zoom video call where our specialist walks through your home with you, documenting every item for comprehensive inventory.
              </p>
            </div>

            <div className="card p-8 animate-fade-in" style={{animationDelay: '0.2s'}}>
              <h3 className="heading-3 mb-4">
                What areas do you serve?
              </h3>
              <p className="body-medium">
                We serve all disaster-prone areas, with special focus on Florida, California, and Gulf Coast states.
              </p>
            </div>

            <div className="card p-8 animate-fade-in" style={{animationDelay: '0.3s'}}>
              <h3 className="heading-3 mb-4">
                Is there a cost for the service?
              </h3>
              <p className="body-medium">
                We're currently offering free services for the first 25 users. Contact us for pricing details.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action with Image */}
      <section className="section-padding bg-white">
        <div className="container-max">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="animate-fade-in">
              <h2 className="heading-2 mb-6">Ready to Get Started?</h2>
              <p className="body-medium mb-8">
                Join the first 25 users and experience our inventory system for free. 
                Protect your belongings with professional documentation.
              </p>
              <a href="/try" className="btn-primary inline-block">
                Start Free Trial
              </a>
            </div>
            
            <div className="animate-fade-in" style={{animationDelay: '0.2s'}}>
              <div className="relative">
                <img 
                  src="/images/armchairs.jpg" 
                  alt="Modern home furnishings showing what we help document" 
                  className="w-full rounded-3xl shadow-lg hover:shadow-xl transition-shadow duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-3xl"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage; 